import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Breadcrumbs } from 'components';
import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import { getBreadcrumbs } from 'store/common/navigation/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

function BreadcrumbsWidgetLayout({ breadcrumbs, isMobile }) {
  return (
    <Breadcrumbs entries={breadcrumbs} className={cx('component', isMobile ? 'mobile' : '')} />
  );
}

BreadcrumbsWidgetLayout.propTypes = {
  breadcrumbs: PropTypes.array,
  isMobile: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  breadcrumbs: getBreadcrumbs(state),
  isMobile: isScreenBelow640(state),
});

const BreadcrumbsWidget = connect(mapStateToProps)(BreadcrumbsWidgetLayout);

export default BreadcrumbsWidget;
